var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-row', {
    staticClass: "mx-0 px-0",
    class: {
      'justify-content-end': _vm.message.sender && _vm.message.sender._id === _vm.getMyInfo._id
    }
  }, [(!_vm.message.badge) ? _c('b-col', {
    staticClass: "spnod-message d-flex",
    class: {
      'spnod-message--white': !_vm.message.sender || _vm.message.sender._id !== _vm.getMyInfo._id,
      'spnod-message--flagged': _vm.message.messageFlaggedBy && _vm.message.messageFlaggedBy.indexOf(_vm.getMyInfo._id) > -1
    },
    attrs: {
      "cols": "10",
      "md": "9",
      "xl": "8"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.toggleFlag(_vm.index, $event)
      },
      "mouseenter": function($event) {
        _vm.popupIndex = _vm.index
      },
      "mouseleave": function($event) {
        _vm.popupIndex = -1
      }
    }
  }, [_c('span', {
    staticClass: "spnod-message-summary__icon",
    class: {
      'fi flaticon-user-2': !_vm.hasAvatar(_vm.message)
    }
  }, [(_vm.hasAvatar(_vm.message)) ? _c('img', {
    staticClass: "spnod-message__avatar",
    attrs: {
      "src": _vm.getAvatar(_vm.message),
      "width": "32",
      "height": "32"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "px-2 w-100"
  }, [(_vm.message.sender) ? _c('span', {
    staticClass: "spnod-message-label spnod-message-label--left"
  }, [_vm._v("\n        " + _vm._s(_vm.message.sender.name + " - " + _vm.getSentDate(_vm.message)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "w-100"
  }, [_c('span', {
    staticClass: "spnod-message__text",
    domProps: {
      "innerHTML": _vm._s(_vm.linkify(_vm.message.messageBodyx))
    }
  }), _vm._v(" "), (_vm.message.messageFlaggedBy.indexOf(_vm.getMyInfo._id) > -1) ? _c('span', {
    staticClass: "spnod-message__flag"
  }, [_c('span', {
    staticClass: "fi flaticon-flag-2"
  })]) : _vm._e()])]), _vm._v(" "), (_vm.popupIndex === _vm.index && _vm.getMyInfo.hasRoles) ? _c('div', {
    staticClass: "spnod-message__meta spnod-layout-grid__row"
  }, [_c('span', {
    staticClass: "spnod-layout-grid__col spnod-layout-grid__col--10 spnod-message__meta--fullheight"
  }, [_vm._v("\n        Read By: \n        "), _vm._l((_vm.message.readers), function(reader, index) {
    return (_vm.message.readers.length > 0) ? _c('span', {
      key: index
    }, [(reader.readBy === _vm.message.client._id && reader.readBy !== _vm.getMyInfo._id) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.message.client.firstName) + " " + _vm._s(_vm.message.client.lastName) + " - " + _vm._s(_vm.getReadByDate(reader)) + ",\n          ")]) : _vm._e(), _vm._v(" "), (reader.readBy !== _vm.message.client._id && reader.readBy !== _vm.getMyInfo._id) ? _c('span') : _vm._e(), _vm._v(" "), (reader.readBy === _vm.getMyInfo._id) ? _c('span', [_vm._v("Me - " + _vm._s(_vm.getReadByDate(reader)))]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), (_vm.message.readers.length === 0) ? _c('span', [_vm._v("\n          No-one\n        ")]) : _vm._e()], 2), _vm._v(" "), _c('span', {
    staticClass: "spnod-layout-grid__col spnod-layout-grid__col--2 spnod-message__flag"
  }, [_c('span', {
    staticClass: "fi flaticon-flag-2"
  })])]) : _vm._e()]) : _c('b-col', {
    attrs: {
      "cols": "10"
    }
  }, [_c('b-row', [_c('p', {
    staticClass: "spnod-message__badge"
  }, [_vm._v(_vm._s(_vm.message.messageBodyx))])])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42096e42","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Messaging/MessageBody.vue
// module id = gYiz
// module chunks = 2